/**
 * NoAccess
 *
 * Minimal screen shown when an account is not active. Clears client storage and
 * presents a branded card instructing the user to contact an administrator.
 */
import React, { useEffect } from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import NoRoleIcon from "../../assets/icons/no-role-icon.svg";
import logo from "../../assets/images/LucyLogo.png";
import Cookies from "js-cookie";

const NoAccess: React.FC<any> = () => {
  useEffect(() => {
    localStorage.clear();
    Cookies.remove("userDetails");
  }, []);
  return (
    <>
      <div className="dashboard-header">
        <div className="dashboard-header-content">
          <div className="dashboard-header-content-logo">
            <img
              src={logo}
              alt="Logo"
              className="dashboard-header-content-logo-img"
            />
          </div>
        </div>
      </div>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="92vh"
        bgcolor="#F9FAFB"
      >
        <Card
          sx={{
            maxWidth: 500,
            p: 4,
            textAlign: "center",
            border: "1.38px solid #E9E9E8",
            borderRadius: 2,
          }}
        >
          <CardContent sx={{ gap: 2 }}>
            <Box display="flex" justifyContent="center" mb={2}>
              <img
                src={NoRoleIcon}
                alt="No Role Icon"
                style={{ width: 68, height: 68 }}
              />
            </Box>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{ color: "#0E0D09" }}
              mb={1}
            >
              No Access
            </Typography>
            <Typography variant="body1" sx={{ color: "#4E4B44" }}>
              Your account is not active.
            </Typography>
            <Typography variant="body1" sx={{ color: "#4E4B44" }}>
              Please contact the system administrator to get access.
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default NoAccess;
